import { styled } from 'styled-components'
import { useMemo } from 'use-memo-one'

import { String } from '@blade/std-lib'
import { useFormatDuration } from '@root/shared'
import { useCurrentDate } from '@root/shared/lib/react'

import { PremiumFeedTableCurrencyCell } from './premium-feed-table-currency-cell'
import { PremiumFeedTablePurchaseColumn } from './premium-feed-table-purchase-column'
import { PremiumFeedTableUserCell } from './premium-feed-table-user-cell'

import type { PremiumFeedTableColumnId } from '../../atoms/reatom-premium-feed-table'
import type { PairActivity } from '../../model'
import type { Column } from '@root/shared/ui-kit/data-table'

export const createPremiumFeedTableColumns = () => {
  const columns: Array<
    Column<PairActivity.PremiumActivity, PremiumFeedTableColumnId>
  > = [
    {
      id: 'currency',
      header: ({ t }) => t('token'),
      render: ({ value }) => <PremiumFeedTableCurrencyCell activity={value} />,
      width: '1fr',
    },
    {
      id: 'purchase',
      header: ({ t }) => t('premium.feed.purchased-item'),
      render: ({ value }) => (
        <PremiumFeedTablePurchaseColumn activity={value} />
      ),
      width: 120,
    },
    {
      id: 'user',
      header: ({ t }) => String.capitalize(t('common.user_one')),
      render: ({ value }) => <PremiumFeedTableUserCell activity={value} />,
      width: 80,
    },
    {
      id: 'timestamp',
      header: ({ t }) => t('common.date'),
      render: ({ value }) => {
        return <DateCell activity={value} />
      },
      width: 80,
      justify: 'end',
    },
  ]

  return columns
}

const DateCell = ({ activity }: { activity: PairActivity.PremiumActivity }) => {
  const currentDate = useCurrentDate({ updateInterval: 'second' })

  const { formatDuration } = useFormatDuration()
  const formatted = useMemo(() => {
    return formatDuration({
      startAt: activity.occurredAt,
      endAt: currentDate,
      mode: 'singleUnitShort',
      withAgo: true,
    })
  }, [activity.occurredAt, currentDate, formatDuration])
  return <DateRoot>{formatted}</DateRoot>
}
const DateRoot = styled.div`
  color: var(--text-7);

  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
`
